import { render, staticRenderFns } from "./ProfileDetails.vue?vue&type=template&id=80bc52d6&scoped=true&"
import script from "./ProfileDetails.vue?vue&type=script&lang=ts&"
export * from "./ProfileDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileDetails.vue?vue&type=style&index=0&id=80bc52d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bc52d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAvatar,VImg,VSkeletonLoader})
